export default __webpack_public_path__ + "static/media/ogc-hero-stock-patio-dark.4a3e8a69.jpg";